import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { pullAsyncObjectDifferences } from '@/helpers/api.helper'
import { getMeInfo } from '@/core/http/me.api'
import './SignUpFifthStep.sass'
import { LoadingSpinner } from '@/components/LoadingSpinner'
import waitingLogoSrc from '@/assets/img/waiting-logo.png'
import completedLogoSrc from '@/assets/img/setup-done-logo.png'
import stepDoneSrc from '@/assets/img/step-completed-mark.png'
import store from '@/core/store'
import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'
import { MoreInfoModal } from '@/pages/LoginPage/components/more-info-modal/MoreInfoModal'
import { useHistory } from 'react-router-dom'
import sessionService from '@/app-domains/user/session/session.service'
import useRenderEvent from '@/core/hooks/useRenderEvent'

export function SignUpFifthStep () {
  const history = useHistory()
  const [readyToLoad, setReadyToLoad] = useState(false)
  const [waiting, setWaiting] = useState(true)
  const [status, setStatus] = useState({
    subscriptionActive: false,
    domainPurchased: false,
    resourcesSetUp: false
  })
  
  useEffect(() => {
    setTimeout(() => {
      store.commit('START_SIDE_MENU:VISIBILITY', false)
    }, 0)
  }, [])

  // TESTING SNIPPET
 
  useRenderEvent(['ME:info_updated'], () => {
    setReadyToLoad(true)
  })
  useEffect(() => {
    if (!readyToLoad) return
    if (!sessionService.isSandboxSession()) return
    setTimeout(() => {
      setStatus({
        subscriptionActive: true,
        domainPurchased: false,
        resourcesSetUp: false
      })
    }, 200)
  
    setTimeout(() => {
      setStatus({
        subscriptionActive: true,
        domainPurchased: true,
        resourcesSetUp: false
      })
    }, 4000)
  
    setTimeout(() => {
      setStatus({
        subscriptionActive: true,
        domainPurchased: true,
        resourcesSetUp: true
      })
      setWaiting(false)
    }, 10000)
  }, [readyToLoad])
  
  useEffect(() => {
    if (!readyToLoad) return
    if (sessionService.isSandboxSession()) return
    const pullingFiles = pullAsyncObjectDifferences({
      getObject: getMeInfo,
      onChange: res => {
        const onboarding = res?.data?.onboarding
        if (onboarding) {
          setStatus(onboarding)
          const { subscriptionActive, domainPurchased, resourcesSetUp } = onboarding
          if (subscriptionActive && domainPurchased && resourcesSetUp) {
            setWaiting(false)
            pullingFiles.stop()
          }
        }
      },
      intervalDuration: 20000,
    })
  }, [readyToLoad])

  const openInfoModal = () => {
    modalService.open(<MoreInfoModal/>)
  }

  const goToMain = () => {
    history.push('/')
  }

  return <div className="waiting-page">
    {waiting && <img className='waiting-page-logo' src={waitingLogoSrc}/>}
    {!waiting && <img className='waiting-page-logo' src={completedLogoSrc}/>}
    {waiting && <div className="waiting-page-text">
      <div className="waiting-page-text-title">We're registering your domain</div>
      <div className="waiting-page-text-subtitle">We'll send you an email as soon as your account is ready</div>
      <div className="waiting-page-text-more-info" onClick={openInfoModal}>More info</div>
    </div>}
    {!waiting && <div className="waiting-page-text">
      <div className="waiting-page-text-title">You're all set!</div>
    </div>}
    <ul className="check-list">
      <li className={classNames({ checked: status.subscriptionActive })}>
        {status.subscriptionActive ? <img src={stepDoneSrc} style={{ marginRight: '10px' }}/> : <LoadingSpinner size='small'/>}
        Subscription Active
      </li>
      <li className={classNames({ checked: status.domainPurchased })}>
        {status.domainPurchased ? <img src={stepDoneSrc} style={{ marginRight: '10px' }}/> : <LoadingSpinner size='small'/>}
        Domain purchased
      </li>
      <li className={classNames({ checked: status.resourcesSetUp })}>
        {status.resourcesSetUp ? <img src={stepDoneSrc} style={{ marginRight: '10px' }}/> : <LoadingSpinner size='small'/>}
        Resources Set Up
      </li>
    </ul>
    <div className={`waiting-page-text-success ${!waiting ? 'displayed' : 'hidden'}`}>
      <div className="waiting-page-text-success-title">Here's what happens next</div>
      <div className="waiting-page-text-success-subtitle">Log in to your new Boxes account.</div>
    </div>
    {!waiting && <>
      <div className="go-to-domain">
        <Button
            content={'Let\'s Go'}
            size='large'
            click={goToMain}
            style={{
              width: '500px'
            }} />
      </div>
      </>}
  </div>
}
